/* src/components/YDWidgets/index.js */

export { default } from './ydWidgets';
